// ─── Filters config per tab (used by Filters component) ───

export const FILTER_CONFIGS = {
  products: {
    priceBand: {
      label: 'Price Band',
      type: 'select',
      options: [
        { value: '', label: 'Any' },
        { value: 'under_10', label: 'Under \u00A310' },
        { value: '10_25', label: '\u00A310 \u2013 \u00A325' },
        { value: '25_50', label: '\u00A325 \u2013 \u00A350' },
      ],
    },
    competitionTolerance: {
      label: 'Competition Tolerance',
      type: 'select',
      options: [
        { value: '', label: 'Any' },
        { value: 'low', label: 'Low only' },
        { value: 'medium', label: 'Low \u2013 Medium' },
        { value: 'high', label: 'Any level' },
      ],
    },
    shippingComplexity: {
      label: 'Shipping Complexity',
      type: 'select',
      options: [
        { value: '', label: 'Any' },
        { value: 'low', label: 'Low' },
        { value: 'medium', label: 'Medium' },
        { value: 'high', label: 'High' },
      ],
    },
    amazonFriendly: {
      label: 'Amazon-Friendly',
      type: 'toggle',
    },
  },
  communities: {
    audienceSizeBand: {
      label: 'Audience Size',
      type: 'select',
      options: [
        { value: '', label: 'Any' },
        { value: 'small', label: 'Small (< 10k)' },
        { value: 'medium', label: 'Medium (10k \u2013 100k)' },
        { value: 'large', label: 'Large (100k+)' },
      ],
    },
    competitionLevel: {
      label: 'Competition Level',
      type: 'select',
      options: [
        { value: '', label: 'Any' },
        { value: 'low', label: 'Low' },
        { value: 'medium', label: 'Medium' },
        { value: 'high', label: 'High' },
      ],
    },
    monetisationType: {
      label: 'Monetisation Type',
      type: 'select',
      options: [
        { value: '', label: 'Any' },
        { value: 'affiliate', label: 'Affiliate' },
        { value: 'digital_products', label: 'Digital Products' },
        { value: 'sponsorships', label: 'Sponsorships' },
        { value: 'memberships', label: 'Memberships' },
      ],
    },
  },
  topics: {
    growthRate: {
      label: 'Growth Rate',
      type: 'select',
      options: [
        { value: '', label: 'Any' },
        { value: 'explosive', label: 'Explosive (50%+)' },
        { value: 'fast', label: 'Fast (30\u201350%)' },
        { value: 'steady', label: 'Steady (15\u201330%)' },
        { value: 'slow', label: 'Slow (< 15%)' },
      ],
    },
    longevity: {
      label: 'Longevity',
      type: 'select',
      options: [
        { value: '', label: 'Any' },
        { value: 'flash', label: 'Flash trend (< 1 month)' },
        { value: 'short', label: 'Short-term (1\u20133 months)' },
        { value: 'medium', label: 'Medium-term (3\u201312 months)' },
        { value: 'evergreen', label: 'Evergreen (12+ months)' },
      ],
    },
    commercialIntent: {
      label: 'Commercial Intent',
      type: 'select',
      options: [
        { value: '', label: 'Any' },
        { value: 'high', label: 'High' },
        { value: 'medium', label: 'Medium' },
        { value: 'low', label: 'Low' },
      ],
    },
  },
};

// ─── Category lists (used by Filters component for Products tab) ───

export const PRODUCT_CATEGORIES = [
  { value: 'pet_products', label: 'Pet Products' },
  { value: 'kitchen_products', label: 'Kitchen Products' },
  { value: 'beauty_tools', label: 'Beauty Tools' },
  { value: 'wellness_self_care', label: 'Wellness & Self Care' },
  { value: 'desk_productivity', label: 'Desk & Productivity' },
  { value: 'home_organisation', label: 'Home Organisation' },
  { value: 'eco_sustainability', label: 'Eco & Sustainability' },
  { value: 'skincare_accessories', label: 'Skincare Accessories' },
  { value: 'hair_styling_tools', label: 'Hair Styling Tools' },
  { value: 'home_decor_accents', label: 'Home Decor Accents' },
  { value: 'car_accessories', label: 'Car Accessories' },
  { value: 'cleaning_laundry_tools', label: 'Cleaning & Laundry Tools' },
  { value: 'smart_home_mini_devices', label: 'Smart Home Mini Devices' },
  { value: 'creator_content_gear', label: 'Creator & Content Gear' },
  { value: 'office_remote_work_tools', label: 'Office & Remote Work Tools' },
  { value: 'parenting_essentials', label: 'Parenting Essentials' },
  { value: 'travel_packing_accessories', label: 'Travel & Packing Accessories' },
  { value: 'fitness_accessories', label: 'Fitness Accessories' },
  { value: 'outdoor_recreation', label: 'Outdoor & Recreation' },
  { value: 'crafts_diy_tools', label: 'Crafts & DIY Tools' },
  { value: 'giftable_novelty_items', label: 'Giftable Novelty Items' },
  { value: 'personal_care_devices', label: 'Personal Care Devices' },
  { value: 'winter_comfort_accessories', label: 'Winter Comfort Accessories' },
  { value: 'summer_seasonal_essentials', label: 'Summer Seasonal Essentials' },
  { value: 'fashion_accessories_jewellery', label: 'Fashion Accessories & Jewellery' },
];
